import {cs}               from "@Common/react/chain-services";
import {Form2}            from "@Common/react/cs-form-2/form2";
import {required}         from "@Common/react/cs-form-2/validators/required";
import {UseState}         from "@Common/react/use-state";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {cnv}              from "@Common/utils/arr-path";
import {
    arrMapToO,
    filterValues,
    isEmpty, omit
}                         from "@Common/utils/objects";

import {BillingFormDisplay} from "./billing-form-display/billing-form-display";

export const BillingAccountForm = ({avaiAccount, persistedBilling, getFieldSum, next}) => cs(
    ["saving", (_, next) => UseState({next})],
    ["data", (_, next) => UseState({next})], // fields
    ["form", ({data}, next) => Form2({
        showErrors: true,
        data: cnv(data, ["value"], (_) => ({
            ...omit(persistedBilling, [
                "name",
                "billingId",
                "amount",
                "itemId",
            ]),
            ...arrMapToO(
                Object.keys(avaiAccount.fields ?? {}).filter((fieldName) => avaiAccount.fields[fieldName].sumMetaFieldsOnApply),
                (fieldName) => formatNumber(getFieldSum(fieldName)),
            ),
            ..._,
        })),
        fields: Object.keys(avaiAccount.fields ?? {}).map((name) => ({
            path: [name],
            validators: avaiAccount.fields[name].required ? [required] : [],
        })),
        next,
    })],
    ["pendingChangeHighlighter", (_, next) => ErrorHighlighter({next})],
    ({form, data, saving, pendingChangeHighlighter}) => next({
        hasPendingChange: !!data.value,
        saving: saving.value,
        hasError: data.value && !form.valid,
        highlightPendingChange: () => {
            pendingChangeHighlighter.start();
        },
        render: ({showErrors, onApply, pendingApply, apiErrors}) => BillingFormDisplay({
            getField: (name) => ({
                ...form.field(name),
                apiError: apiErrors?.some((apiError) => apiError.field === name), // TODO
            }),
            apiErrors,
            onApply: (!saving.value && (data.value || pendingApply) && form.valid) && (async () => {
                saving.onChange(true);

                const result = await onApply({fields: data.value});
                if (result) {
                    data.change((fields1) => {
                        const fields = filterValues(fields1, (v, k) => v !== fields1[k]);
                        return isEmpty(fields) ? null : ({
                            // omitted adding
                            fields: fields,
                        });
                    });
                }
                saving.onChange(false);

            }),
            account: avaiAccount,
            showErrors, pendingChangeHighlighter,
        }),

        autoApply: isEmpty(avaiAccount.fields),
    }),
);

const formatNumber = (num) => (Math.round(num*100)/100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
